

export const base_url = 'http://18.222.190.66:8080/api/v1/ezzytrace/'                //DEV-TEST
